import React from 'react';
import { useNavigate } from 'react-router-dom';
import {
  AsyncMultiSelectDropdown,
  FormTemplate,
  SubmitButton,
} from 'ui-builder';
import {
  ProjectType,
  usePlansService,
  useProjectPlanService,
} from 'nekst-api';
import { usePopupFormManager } from 'features/nekst-widgets';
import { useProjectContext } from '../../view/ProjectContext';

function WorkflowMultiDropdown(props: {
  projectType: ProjectType;
  setupAreaId: number;
}) {
  const plansService = usePlansService();

  return (
    <AsyncMultiSelectDropdown
      source="plansIds"
      label="Select Workflow(s)"
      loadOptionsFunc={async () => {
        const plans = await plansService.getAllTeamPlans(props.projectType, props.setupAreaId);
        return plans.map((plan) => ({
          value: plan.id,
          label: plan.name,
        }));
      }}
    />
  );
}

interface WorkflowSelectionFormData {
  plansIds: number[];
}

export default function WorkflowSelectionModal(props: { projectId: number }) {
  const projectPlanService = useProjectPlanService();
  const popupFormManager = usePopupFormManager();
  const navigator = useNavigate();
  const projectContext = useProjectContext();

  const projectType = projectContext.data?.type;
  const setupAreaId = projectContext.data?._setupArea?.id;

  const submitFunc = async (data: WorkflowSelectionFormData) => {
    const result = await projectPlanService.addNewPlansToProject(
      props.projectId,
      data.plansIds,
    );

    popupFormManager.closePopup();

    navigator(`/transactions/${props.projectId}/plans/${result.id}/launch/keydates`);
  };

  if (!projectType || !setupAreaId) {
    return null;
  }

  return (
    <FormTemplate<WorkflowSelectionFormData>
      submitFormFunc={submitFunc}
      initialData={{ plansIds: [] }}
      title="Add Workflow"
      buttons={<SubmitButton text="Continue" />}
    >
      <WorkflowMultiDropdown
        projectType={projectType}
        setupAreaId={setupAreaId}
      />
    </FormTemplate>
  );
}
